// Notification sound using the handpan audio clip (first 5 seconds)
const SOUND_URL = '/sounds/notification.mp3';
const PLAY_DURATION = 5000; // 5 seconds

let audioElement = null;
let muted = localStorage.getItem('gk_notification_muted') === 'true';

export function isNotificationMuted() {
  return muted;
}

export function setNotificationMuted(val) {
  muted = val;
  localStorage.setItem('gk_notification_muted', String(val));
  if (val && audioElement) {
    audioElement.pause();
    audioElement.currentTime = 0;
  }
}

export function unlockAudio() {
  // Pre-create the audio element on first user interaction (iOS requirement)
  if (!audioElement) {
    audioElement = new Audio(SOUND_URL);
    audioElement.volume = 0.5;
    audioElement.preload = 'auto';
    // iOS needs a play attempt during a gesture
    audioElement.play().then(() => { audioElement.pause(); audioElement.currentTime = 0; }).catch(() => {});
  }
}

export function playNotificationChime() {
  if (muted) return;

  try {
    if (!audioElement) {
      audioElement = new Audio(SOUND_URL);
      audioElement.volume = 0.5;
    }

    // Reset to start and play first 5 seconds
    audioElement.currentTime = 0;
    audioElement.play().catch(() => {});

    // Stop after 5 seconds
    setTimeout(() => {
      if (audioElement && !audioElement.paused) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
    }, PLAY_DURATION);
  } catch (e) {
    console.error('Notification sound failed:', e);
  }
}
